

// src/components/HostsTable/HostsTable.jsx
import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { useRestoUsers } from "../../../../hooks/useRestoUsers"
import { useEvaluation } from "../../../../hooks/useEvaluations"
import { FiStar } from "react-icons/fi"
import { getEvaluationShortLabel } from "../../../../constants/evaluationLabels"

const Select = styled.select`
  padding: 0.4rem 0.6rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.9rem;
`
const Evaluations = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
  font-family: "Poppins", sans-serif;
`;

const EvaluationsHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.5fr;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #000;
  margin-bottom: 15px;
  padding-bottom: 12px;

  h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
  }
`;

const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 50px 1fr 1fr;
  font-weight: 500;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
  color: #888;
  font-size: 14px;
`;

const EvaluationItem = styled.div`
  display: grid;
  grid-template-columns: 50px 1fr;
  border: 1px solid #e5e5e5;
  border-radius: 14px;
  margin: 14px 0;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`;

const EvaluationNumber = styled.div`
  font-weight: 600;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
`;

const EvaluationContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  padding: 10px 16px;

  &:first-child {
    border-bottom: 1px solid #eee;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
`;

const Category = styled.div`
  font-weight: 600;
  font-size: 15px;
`;

const Subinfo = styled.div`
  font-size: 13px;
  color: #666;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StarsContainer = styled.span`
  display: flex;
`;

const Star = styled(FiStar).withConfig({
  shouldForwardProp: (prop) => prop !== 'filled' && prop !== 'partial'
})`
  font-size: 18px;
  margin-right: 2px;
  color: ${({ $filled, color }) => ($filled ? color : "#ccc")};
`;

function Stars({ value = 0, max = 5, color = "red" }) {
    const fullStars = Math.floor(value);
    const fraction = value - fullStars;

    return (
        <StarsContainer>
            {[...Array(max)].map((_, i) => {
                if (i < fullStars) {
                    return <Star key={i} $filled={true} color={color} />;
                } else if (i === fullStars && fraction > 0) {
                    return <Star key={i} $filled={true} color={color} style={{ opacity: fraction }} />;
                } else {
                    return <Star key={i} $filled={false} color={color} />;
                }
            })}
        </StarsContainer>
    );
}

export function EvaluationCeoTab({ restoName = "Todos" }) {
    const { getAllRestoHost, hostResto } = useRestoUsers();
    const { getEvalByResto, restoEvaluation, getEvalRestoById, getEvalByRestos } = useEvaluation()
    const [selectedRestaurant, setSelectedRestaurant] = useState(null)
    const [name, setName] = useState(restoName)

    useEffect(() => {
        getEvalByRestos();
        getAllRestoHost();
    }, [])

    const handleHostChange = (value) => {
        setSelectedRestaurant(value);

        if (value === "all") {
            getEvalByResto();
            setName(restoName);
        } else {
            getEvalRestoById(value);
            const n = (hostResto || [])?.find(e => e._id === value);
            setName(n?.name);
        }
    }

    return (
        <>
            <Evaluations>
                <EvaluationsHeader>
                    <Select value={selectedRestaurant} onChange={e => handleHostChange(e.target.value)}>
                        <option value="all">{restoName}</option>
                        {hostResto.map(r => (
                            <option key={r._id} value={r._id}>
                                {r.name}
                            </option>
                        ))}
                    </Select>
                </EvaluationsHeader>

                <TableHeader>
                    <span>#</span>
                    <span>Categoría</span>
                    <span>Valoración</span>
                </TableHeader>

                {(restoEvaluation || []).map((item, idx) => {
                  const available = ["question1", "question2", "question3", "question4", "question5"];
                    return available.includes(item._id) && (
                        <EvaluationItem key={idx}>
                            <EvaluationNumber>{idx + 1}</EvaluationNumber>

                            <EvaluationContent>
                                <Row>
                                    <Left>
                                        <Category>{getEvaluationShortLabel(item._id, item.name || "Sin nombre")}</Category>
                                        <Subinfo>{name}</Subinfo>
                                    </Left>
                                    <Right>
                                        <Stars value={item.avg} color="red" />
                                    </Right>
                                </Row>

                                <Row>
                                    <Left>
                                        <Subinfo>Promedio general almacenes</Subinfo>
                                    </Left>
                                    <Right>
                                        <Stars value={item.other} color="#666" />
                                    </Right>
                                </Row>
                            </EvaluationContent>
                        </EvaluationItem>
                    )
                })}
            </Evaluations>

            <div style={{ height: 100 }}></div>
        </>
    )
}
